<template>
    <section class="page">
        <ui-header v-if="header" :sidebar="false" />
        <slot name="bradcrumbs" />
        <section class="body" :class="bodyDesign">
            <div class="coll-1">
                <div class="row-1" :style="{'background': bgRow1}" >
                    <div class="page-title">
                        <div v-if="titleTop" class="title-top">{{ titleTop }}</div>

                        <div v-if="pageName" class="title">{{ pageName }}</div>

                        <div v-if="pageSubtitle" class="subtitle">{{ pageSubtitle }}</div>
                        <div v-else class="subtitle">
                            Encontramos {{ totalRecords }}
                            {{ totalRecords > 1 ? 'registros' : 'registro' }}.
                        </div>
                    </div>

                    <div v-if="hasViewOptions" class="view-options">
                        <slot name="viewOptions" />
                    </div>

                    <div v-if="showSearch" class="filters-options">
                        <slot name="filters-options" />
                        <span class="search">
                            <span class="search-input-label">{{ searchInputLabel }}</span>
                            <ui-search-box
                                :event="searchEvent"
                                :placeholder="searchInputPlaceholder"
                                :bg-color="bgColorSearchBox"
                                :placeholder-color="placeholderColorSearchBox"
                            />
                        </span>
                        <button v-if="!hideFilters" class="filter-btn" :class=" {'active': showFilters}" @click="toggleFilters">
                            <i class="fal fa-sliders-h" />
                            Filtrar Dados
                        </button>
                        <span v-if="watchFilter" class="clean" @click="cleanEvent(clearFiltersEvent)">
                            Limpar Filtros
                        </span>
                    </div>
                    <div class="actions">
                        <slot v-if="hasActions" name="actions" />
                        <ui-button
                            v-if="hasAddButton" type="submit"
                            design="md primary"
                            @click="addAction(addEvent)">
                            {{ addButtonText }}
                            <i :class="addButtonIcon" />
                        </ui-button>
                        <ui-menu-card v-if="hasMenuCard" :icon="menuCardIcon">
                            <slot name="menuCard" />
                        </ui-menu-card>
                    </div>
                </div>

                <div v-if="contextActionBar">
                    <slot name="contextActionBar"/>
                </div>

                <div class="row-2" :class="{'row-2-position': slotPageList}">
                    <div v-if="hasAsideLeft" class="aside-left scroll-color">
                        <slot name="asideLeft" />
                    </div>

                    <slot name="content" />
                </div>
            </div>

            <transition name="coll-2" mode="in-out">
                <div v-show="showFilters" class="coll-2" :class="{ collId: true,  'visibility': showFilters == true }">
                    <div class="filter-head">
                        <span class="filter-icon">
                            <i class="fal fa-sliders-h" />
                        </span>
                        <div class="title">{{ searchTitle }}</div>
                        <button class="button-close" type="button" @click="toggleFilters">
                            <i class="fal fa-times" />
                        </button>
                    </div>
                    <div class="filter-body scroll-color">
                        <slot name="filters" />
                    </div>
                    <div class="filter-footer">
                        <ui-button type="submit" design="md primary" @click="filtersEvent(filtersApplyEvent)">
                            Aplicar
                        </ui-button>
                    </div>
                </div>
            </transition>
        </section>

        <ui-active-offer-modal />
        <uiRatingNPS />
        <ui-feedback-modal />
        <ui-thank-feedback-modal />
    </section>
</template>

<script>
import uiHeader from '@/components/ui/panel-header'

import { uiMenuCard, uiSearchBox } from '@/components/ui'
import { uiActiveOfferModal } from '@/components/ui-facilita/active-offer'
import uiFeedbackModal from '@/components/ui-facilita/modals/feedback-modal'
import uiThankFeedbackModal from '@/components/ui-facilita/modals/feedback-modal/thank-feedback-modal'
import { uiButton } from '@/components/ui/buttons'
import { helpersMixin, utilMixin } from '@/mixins'
import { storage } from '@/services/storage'
import { mapGetters } from 'vuex'
import { defaultGtm } from './default'

import uiRatingNPS from '@/components/ui-facilita/rating/nps/index.vue'

export default {
	name: 'ui-page-list',

    components: {
        uiHeader,
        uiSearchBox,
        uiButton,
        uiMenuCard,
        uiActiveOfferModal,
        uiFeedbackModal,
        uiThankFeedbackModal,
		uiRatingNPS
    },

    mixins: [helpersMixin, utilMixin],

    props: {
        /**
         * Utilize para alterar o nome da pagina
         */
        pageName: {
            type: String,
            default: "Listagem",
        },
        /**
         * Utilize para alterar o nome da pagina
         */
        pageSubtitle: {
            type: String,
            default: "",
        },
        header: {
            type: Boolean,
            default: true
        },
        /**
         * Utilize para alterar o nome da pagina
         */
        searchTitle: {
            type: String,
            default: "Filtrar",
        },
        /**
         * Utilize para alterar o icone do sidebar da listagem
         */
        searchTitleIcon: {
            type: String,
            default: "fal fa-sliders-h",
        },
        /**
         * Utilize para alterar o nome da pagina
         */
        searchInputPlaceholder: {
            type: String,
            default: "Buscar",
        },
        /**
         * Utilize para trocar o nome da label
         */
        searchInputLabel: {
            type: String,
            default: "Buscar:",
        },
        /**
         * Utilize para alterar o nome da pagina
         */
        addButtonText: {
            type: String,
            default: "Adicionar",
        },
        /**
         * Utilize para alterar o nome da pagina
         */
        addButtonIcon: {
            type: String,
            default: "far fa-plus",
        },
        buttonIcon: {
            type: Boolean,
            required: false,
            default: true
        },
        /**
         * Utilize para mostrar ou esconder o campo de busca e filtro
         */
        showSearch: {
            type: Boolean,
            required: false,
            default: true,
        },
        /**
         * Utilize para modificar o nome do evento de busca
         * do data table
         */
        searchEvent: {
            type: String,
            required: false,
            default: ''
        },
        /**
         * Valor da propriedade name do componente parar adicionar
         */
        hideFilters: {
            required: false,
            type: Boolean,
            default: false
        },
        /**
         * Valor da propriedade name do componente parar adicionar
         */
        addEvent: {
            type: String,
            required: false,
            default: ''
        },
        /**
         * Id do componente parar adicionar
         */
        filtersApplyEvent: {
            type: String,
            required: true
        },
        /**
         * utilize para usar no menucard
         */
        menuCardIcon: {
            type: String,
            default: 'far fa-ellipsis-v'
        },
        /**
         * Evento para limpar os filtros
        */
        clearFiltersEvent: {
            type: String,
            required: false,
            default: ''
        },
        /**
         * Define se existira botão de adicionar registro
        */
        hasAddButton: {
            required: false,
            type: Boolean,
            default: true
        },
        /**
         * Classes para o container do componente
        */
        bodyDesign: {
            type: String,
            default: ''
        },
        /**
         * Background para o container row1 do componente
        */
        bgRow1: {
            type: String,
            default: ''
        },
        /**
         * Background interno do SearchBox
        */
        bgColorSearchBox: {
            type: String,
            default: '#F6F7FD'
        },
        /**
         * Font color placeholder do search-box
        */
        placeholderColorSearchBox: {
            type: String,
            default: '#7D8094'
        },
        /**
         * Define o texto do botão de salvar os filtros no storage
        */
        filterStorageText: {
            required: false,
            type: String,
            default: 'Salvar Filtros'
        },
        /**
         * Define se haverão botões de ação
         */
        hasActions: {
            type: Boolean,
            required: false,
            default: true
        },
        /**
         * Define um título acima do nome da página
         */
        titleTop: {
            type: String,
            required: false,
            default: ''
        },
        /**
         * Define se a lista esta dentro de outro template
         */
        slotPageList: {
            type: Boolean,
            default: false
        },
        contextActionBar: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            collId: 'coll-2-' +this._uid,
            showFilters: false,
            gtm: { ...defaultGtm() },
            watchFilter: false
        }
    },

    computed: {
        ...mapGetters({
            totalRecords: 'dataTable/getTotal',
        }),

        //Verifica se o SLOT existe
        hasViewOptions() {
            return this.$slots.viewOptions ? true : false
        },
        //Verifica se o SLOT existe
        hasMenuCard(){
            return this.$slots.menuCard ? true : false
        },

        //Verifica se o SLOT existe
        hasAsideLeft(){
            return this.$slots.asideLeft ? true : false
        },

        //Verifica se o SLOT existe
        hasAsideRight(){
            return this.$slots.asideRight ? true : false
        }
    },

	mounted() {
		this.$root.$on('set-filter-selected-active', filter => {
            //seta o botão de limpar filtros
            let hasFilter = filter.filter(res => this.$mx_hasValue(res.value))
            this.watchFilter = hasFilter.length > 0

            this.filtersSaved[this.filtersApplyEvent] = [ ...filter ]
            storage.set('filters_saved', JSON.stringify(this.filtersSaved))
        })
	},

    created() {
        this.loadFilterPage()
    },

    beforeCreate() {
        this.$nextTick(() => {
            if (JSON.parse(storage.get('show_filters_list_' + this.snakeCase(this.pageName)))) {
                this.showFilters = JSON.parse(storage.get('show_filters_list_'+this.snakeCase(this.pageName)))
            }
            const companiesRestricted = this.$store.getters.companiesRestricted
            let user = JSON.parse(storage.get('user_logged'))
            let config = JSON.parse(storage.get('api_config'))

            window.dataLayer[0].user 				 = user
            window.dataLayer[0].configs 			 = JSON.parse(storage.get('get-configs-data'))
            window.dataLayer[0].companies_restricted = companiesRestricted
            window.dataLayer[0].instance_user_id 	 = config.instance + '_' + user.id
            window.dataLayer[0].instance 	 		 = config.instance
        })
    },

    beforeDestroy(){
        this.$root.$off('set-filter-selected-active')
        storage.set('show_filters_list_'+this.snakeCase(this.pageName), false)
    },

    methods: {
        //verifica se existe algum filtro para esta tabela e ativa o limpar filtro
        addAction(addEventName) {
            this.$root.$emit(addEventName)
        },
        filtersEvent(filtersEventName) {
            this.$root.$emit('clear-search-input')
            this.$root.$emit(filtersEventName)
            this.$root.$emit('search-team-selector')
            this.$gtm.trackEvent(this.gtm.filter)
        },
        async cleanEvent(cleanEventName) {
            await this.$root.$emit(cleanEventName)
            this.watchFilter = false
        },
        /**
         * Salva o status do menu {visivel ou escondido} no local-storage
         * É um valor Booleano.
         */
        toggleFilters(){
            this.showFilters = !this.showFilters
            this.$root.$emit('show-filters-active', this.showFilters)
            this.$gtm.trackEvent(this.gtm.openFilter)
            this.$nextTick(() => {
                storage.set('show_filters_list_'+this.snakeCase(this.pageName), JSON.stringify(this.showFilters))
            })
        },

        /**
         * Verifica se existe um filtro no localstorage para trazelo ao carregar a página
         */
        async loadFilterPage(){
            this.filtersSaved = JSON.parse(storage.get('filters_saved')) || {}
            if (this.filtersSaved?.[this.filtersApplyEvent]) {
                let hasFilterStorage = this.filtersSaved[this.filtersApplyEvent].filter(res => this.$mx_hasValue(res.value))
                if(hasFilterStorage.length > 0) {
                    this.watchFilter = true
                    let reverseFilter = this.clearChangeFilter(this.filtersSaved[this.filtersApplyEvent])
                    this.$emit('input', reverseFilter)
                } else {
                    this.$emit('input')
                }
            } else {
                this.filtersSaved[this.filtersApplyEvent] = []
                this.$emit('input')
            }
        },

        resverseFilterMaker(value, hasArray) {
            if (!value) return
            let newArr =  hasArray ? value : value.split(',')
            let setArr = []
            newArr.map(res => {
                setArr.push(res.replace(/[^\w\s]/gi, ''))
            })
            return setArr
        },

        clearChangeFilter(filters) {
            let modifiedFilters = filters.map(filter => {
                let modifiedFilter = { ...filter }; // Cria uma cópia do filtro original

                let value = modifiedFilter.value;
                if (['origin_id', 'product_id', 'funnel_stage_status_id', 'tags', 'status_reserve'].includes(modifiedFilter.name)) {
                    modifiedFilter.value = this.resverseFilterMaker(modifiedFilter.value, Array.isArray(modifiedFilter?.value));
                }
                if (modifiedFilter.name == 'tasks') {
                    if (value === 2) value = '';
                    else if (value === 3) value = 0;
                    modifiedFilter.value = value;
                }

                if (modifiedFilter.name === 'reserves') {
                    if(value === 2) value = "0"
                    if(value === 1) value = "1"
                    if(value === 3) value = ""
                    modifiedFilter.value = value;
                }

                return modifiedFilter;
            });
            return modifiedFilters;
        },
    }
}
</script>

<style lang="stylus" scoped>
@import 'styles.styl';
</style>
